function Overlay( props ) { 
	return (
		<div className='backdrop' onClick={props.onDone}></div>
	);
}

export default Overlay;